module.exports = __webpack_public_path__ + "img/org_1.d84776ff.jpeg";